import { Button, Heading } from "@clayui/core";
import ClayLayout from "@clayui/layout";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ClayLink from "@clayui/link";
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { OTPVerifications } from "../../../apis/useApi";
import { dubaiChamberScopeKey, formatTime } from "../../../config";
import CutButton from "../../../generic-components/customCutButton/CutButton";
import { RootState } from "../../../redux/store";
import Loader from '../../../components/loader/Loader';

const OtpVerification: React.FC<{
    setStep: React.Dispatch<React.SetStateAction<number>>;
}> = ({ setStep }) => {
    const {
        formState: { errors },
        handleSubmit
    } = useForm();
    const { basicInformationDetails } = useSelector(
        (state: RootState) => state.basicInformationSlice
    );
    const [isLoading, setIsLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [timer, setTimer] = useState(180);
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 1000);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;
        if (isResendDisabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        if (interval) clearInterval(interval);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        } else if (!isResendDisabled && timer !== 0) {
            if (interval) clearInterval(interval);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isResendDisabled, timer]);

    const onSubmit = async (e: any) => {
        setResponseMessage('');
        setIsLoading(true);
        const response = await OTPVerifications(
            `/v1/otp-service/validate-otp/${basicInformationDetails?.contactWorkEmail}/${otp}?scopeKey=${dubaiChamberScopeKey}`
        );
        // setStep(2);
        if (response?.data?.statusCode == 200) {
            setIsLoading(false);
            setStep(2);
            toast.success(response?.data?.statusMessage, {
                theme: 'light',
                autoClose: 2000
            });
        } else {
            setIsLoading(false);
            toast.error(response?.data?.statusMessage, {
                theme: 'light',
                autoClose: 2000
            });
        }
    };

    const handleResendOTP = async (e: any) => {
        e.preventDefault();
        setResponseMessage('');
        setTimer(180);
        setIsResendDisabled(true);
        setIsDisable(false);
        setOtp('');
        const response = await OTPVerifications(
            `/v1/otp-service/generate-otp/${basicInformationDetails?.contactWorkEmail}?scopeKey=${dubaiChamberScopeKey}`
        );
        if (response?.data?.statusCode == 200) {
            setIsLoading(false);
            toast.success(response?.data?.statusMessage, {
                theme: 'light',
                autoClose: 2000
            });
        } else {
            setIsLoading(false);
            toast.error(response?.data?.statusMessage, {
                theme: 'light',
                autoClose: 2000
            });
        }
    };

    const handleOTP = (e: string) => {
        setResponseMessage('');
        setOtp(e);
    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <ClayLayout.ContentSection className="verification_container">
                    <ClayLayout.Row
                        justify="center"
                        className="verification_header"
                    >
                        <ClayLayout.Col size={12}>
                            <Heading level={4} weight="bold">
                                OTP Verification
                            </Heading>
                        </ClayLayout.Col>
                        <ClayLayout.Col size={12} className="verification_text">
                            One-time password has been sent to your register
                        </ClayLayout.Col>
                        <ClayLayout.Col size={12} className="verification_text">
                            email address (
                            {basicInformationDetails?.contactWorkEmail}). It is
                            valid for 3 Minutes.
                        </ClayLayout.Col>
                    </ClayLayout.Row>
                    <form onSubmit={handleSubmit(onSubmit)} className="w-100">
                        <ClayLayout.Row justify="center" className="mb-4">
                            <ClayLayout.Col size={12} className="detail-inputs">
                                <OTPInput
                                    value={otp}
                                    onChange={(e) => handleOTP(e)}
                                    numInputs={6}
                                    renderInput={(props) => (
                                        <input
                                            {...props}
                                            type="tel"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            className="verification_input custom_input mr-4 no-spinner"
                                            required
                                        />
                                    )}
                                />
                                {responseMessage && (
                                    <p className="response_message">
                                        {/* {!isLoading && responseMessage} */}
                                    </p>
                                )}
                            </ClayLayout.Col>
                        </ClayLayout.Row>

                        <ClayLayout.ContentSection className="resend_otp">
                            <div>
                                <span className="otp-text">
                                    Didn’t receive OTP code? Please wait{' '}
                                </span>{' '}
                                <ClayLink displayType="primary">
                                    {formatTime(timer)}
                                </ClayLink>
                            </div>
                            <Button
                                className="resend-btn mt-4"
                                disabled={isResendDisabled}
                                onClick={handleResendOTP}
                            >
                                <ClayLink displayType="primary">
                                    Resend OTP
                                </ClayLink>
                            </Button>
                        </ClayLayout.ContentSection>
                        <div className="button_container mt-4 d-flex justify-content-center">
                            {/* <SubmitButton label="Verify Email" /> */}
                            <CutButton
                                title="Next"
                                buttonType="submit"
                                disabled={false}
                            />
                        </div>
                    </form>
                </ClayLayout.ContentSection>
            )}
        </>
    );
};

export default OtpVerification;
